import { render, staticRenderFns } from "./ContentBoxes.vue?vue&type=template&id=3174f904&scoped=true&"
import script from "./ContentBoxes.vue?vue&type=script&lang=js&"
export * from "./ContentBoxes.vue?vue&type=script&lang=js&"
import style0 from "./ContentBoxes.vue?vue&type=style&index=0&id=3174f904&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3174f904",
  null
  
)

export default component.exports